import { Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { TenantContextProvider, TenantSelectionGate, useAuthSession } from '@modeling/account';
import { LoginPage } from '../components/auth/LoginPage';
import { ProtectedRoutes } from '../components/auth/ProtectedRoutes';
import {
  ForbiddenPage,
  ManagementAccessRoutes,
  PlatformAdminOnlyRoutes,
} from '../components/auth/ManagementAccessRoutes';
import { AppLayout } from '../components/layout/AppLayout';
import { AdminScopeProvider } from '../context/AdminScopeContext';
import { HomePage } from '../pages/HomePage';
import { TenantListPage } from '../pages/tenant/TenantListPage';
import { TenantDetailPage } from '../pages/tenant/TenantDetailPage';
import { TenantSpaceAdminPage } from '../pages/tenant/TenantSpaceAdminPage';
import { SchemaProfilesPage } from '../pages/schema/SchemaProfilesPage';
import { WorkflowProfilesPage } from '../pages/workflow/WorkflowProfilesPage';
import { SchemaIndexesPage } from '../pages/schema/SchemaIndexesPage';
import { SchemaProfileDesignRedirect } from './SchemaProfileDesignRedirect';
import { GitCredentialsPage } from '../pages/git/GitCredentialsPage';
import { AiUsagePage } from '../pages/usage/AiUsagePage';
import { CreditPage } from '../pages/credit/CreditPage';

function AuthenticatedApp() {
  return (
    <TenantContextProvider>
      <TenantSelectionGate>
        <AdminScopeProvider>
          <Outlet />
        </AdminScopeProvider>
      </TenantSelectionGate>
    </TenantContextProvider>
  );
}

export function AppRoutes() {
  const session = useAuthSession();

  return (
    <Routes>
      <Route
        path="/login"
        element={session.authenticated ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route element={<ProtectedRoutes />}>
        <Route element={<AuthenticatedApp />}>
          <Route element={<AppLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/forbidden" element={<ForbiddenPage />} />
            <Route element={<ManagementAccessRoutes />}>
              <Route path="/tenants" element={<TenantListPage />} />
              <Route path="/tenants/:tenantId" element={<TenantDetailPage />} />
              <Route element={<PlatformAdminOnlyRoutes />}>
                <Route path="/tenants/:tenantId/spaces" element={<TenantSpaceAdminPage />} />
                <Route path="/schema-profiles" element={<SchemaProfilesPage />} />
                <Route path="/schema-profiles/:profileId" element={<SchemaProfilesPage />} />
                <Route path="/workflow-profiles" element={<WorkflowProfilesPage />} />
                <Route path="/workflow-profiles/:profileId" element={<WorkflowProfilesPage />} />
                <Route path="/schema-indexes" element={<SchemaIndexesPage />} />
                <Route
                  path="/schema-profiles/:profileId/design"
                  element={<SchemaProfileDesignRedirect />}
                />
                <Route path="/git-credentials" element={<GitCredentialsPage />} />
                <Route path="/ai-usage" element={<AiUsagePage />} />
                <Route path="/credits" element={<CreditPage />} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
